<template>
  <!-- Start Boxes Area -->
  <section class="boxes-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="single-box">
            <div class="icon">
              <i data-feather="server"></i>
            </div>
            <h3>{{ t('feature_secure_title') }}</h3>
            <p>{{ t('feature_secure_p') }}</p>
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="single-box bg-f78acb">
            <div class="icon">
              <i data-feather="code"></i>
            </div>
            <h3>{{ t('feature_serverless_title') }}</h3>
            <p>{{ t('feature_serverless_p') }}</p>
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="single-box bg-c679e3">
            <div class="icon">
              <i data-feather="users"></i>
            </div>
            <h3>{{ t('feature_scalable_title') }}</h3>
            <p>{{ t('feature_scalable_p') }}</p>
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="single-box bg-eb6b3d">
            <div class="icon">
              <i data-feather="git-branch"></i>
            </div>
            <h3>{{ t('feature_simple_title') }}</h3>
            <p>{{ t('feature_simple_p') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End Boxes Area -->
</template>

<script>
import { onMounted } from 'vue'
import feather from 'feather-icons'
import i18next from '../i18next.js'

export default {
  name: 'BoxesArea',
  setup() {
    // Simple translation function
    const t = (key) => i18next.t(key);
    
    onMounted(() => {
      // Reinitialize Feather Icons
      feather.replace()
    })
    
    return { t }
  }
}
</script>

<style scoped>
/* Box area styling is handled in the imported CSS */
</style>